module.exports = __webpack_public_path__ + "img/bot.9ac602e0.png";